import request from '@/axios'

// 01-获取员工基础信息
export function getStaffInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/staff/wx_staff/getStaffInfo',
    method: 'post',
    data
  })
}

// 02-提供省市区域列表
export function getRegionList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/common/region/region/getRegionList',
    method: 'post',
    data
  })
}

// 03-提供基础筛选项列表
export function getBaseConfigList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/common/base/base_config/getBaseConfigList',
    method: 'post',
    data
  })
}

// 04-提供岗位列表
export function getStationList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/department/wx_station/getStationList',
    method: 'post',
    data
  })
}

// 05-合伙人店长-保存信息
export function saveStaffShopowner(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/staff/wx_staff/saveStaffShopowner',
    method: 'post',
    data
  })
}

// 06-合伙人店员-保存信息
export function saveStaffClerk(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/staff/wx_staff/saveStaffClerk',
    method: 'post',
    data
  })
}

// 07-保存员工信息
export function saveStaffInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/staff/wx_staff/saveStaffInfo',
    method: 'post',
    data
  })
}

// 09-获取部门选项信息
export function getDepartmentOptionList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/department/wx_department/getDepartmentOptionList',
    method: 'post',
    data
  })
}

// 12-获取员工所有信息 （备注查询详细接口）
export function getStaffAllInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/staff/wx_staff/getStaffAllInfo',
    method: 'post',
    data
  })
}

// 09-获取民族列表
export function getNationList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/common/base/nation/getNationList',
    method: 'post',
    data
  })
}

// 11-获取部门选项树结构
export function getDepartmentOptionNewList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/department/wx_department/getDepartmentOptionNewList',
    method: 'post',
    data
  })
}

// 14-获取合伙人门店选项(新2021-7-14)
export function getPartnerStoreList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/department/wx_department/getPartnerStoreList',
    method: 'post',
    data
  })
}

